// Module
var code = "<div class=\"cs-login-logo\"> <img class=\"cs-logo\" src=\"images/logos/cs_logo_white.svg\" translate-attr=\"{ alt: 'title_contrastSecurity' }\"> </div> ";
// Exports
var _module_exports =code;;
var path = '/views/cs-login-logo.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;